module.exports = __webpack_public_path__ + "static/wines-ef00bb63a083f737e3711fcfb9b7ecf8.jpg";